import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;

  .ant-card-meta-title {
    margin-bottom: 0 !important;
  }
`;
export const OptionText = styled.p`
  color: #c90000;
  cursor: pointer;
  font-weight: 600;
  margin: 0;
  transition: 0.2s;
`;